import React, { useRef, useEffect, memo } from 'react';
import classnames from 'classnames';
import './ParticipantsGridItemVideo.scss';
import { noop } from 'lodash';
const ParticipantsGridItemVideoComponent = ({ videoElementPromise, type }) => {
    const refVideoContainer = useRef(null);
    useEffect(() => {
        if (!videoElementPromise)
            return;
        videoElementPromise.then((videoElement) => {
            if (!videoElement || !videoElement.srcObject)
                return;
            refVideoContainer.current.appendChild(videoElement);
            if (videoElement.paused) {
                videoElement.play().catch(noop);
            }
        });
    }, [videoElementPromise]);
    return (<div className={classnames({
            'ml-pg-video': true,
            [`ml-pg-video--${type}`]: true,
        })} ref={refVideoContainer}/>);
};
export const ParticipantsGridItemVideo = memo(ParticipantsGridItemVideoComponent);
